import React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

const TaskInstructions = ({ instructions }) => (
	<Box
		role="region"
		aria-label="Task instructions"
		sx={{ width: "100%", height: "100%", overflowY: "auto", p: 4, boxSizing: "border-box", backgroundColor: "background.paper", userSelect: "text" }}
	>
		<Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: 700 }}>
			Task Instructions
		</Typography>
		<Typography component="div" sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere", lineHeight: 1.7 }}>
			{instructions}
		</Typography>
	</Box>
)

export default TaskInstructions
